import React from 'react';

// peerConnectionSingleton.ts
class PeerConnectionSingleton {
  private static instance: PeerConnectionSingleton;
  public pcRef: React.RefObject<RTCPeerConnection | null>;

  private constructor() {
    this.pcRef = React.createRef<RTCPeerConnection>();
  }

  // Static method to get the instance of the singleton
  static getInstance(): PeerConnectionSingleton {
    if (!PeerConnectionSingleton.instance) {
      PeerConnectionSingleton.instance = new PeerConnectionSingleton();
    }
    return PeerConnectionSingleton.instance;
  }

  // Accessor to retrieve the peer connection reference
  getPeerConnection(): React.RefObject<RTCPeerConnection | null> {
    return this.pcRef;
  }
}

export default PeerConnectionSingleton;
